import {
  Button,
  Form,
  Formik,
  FormikControl,
  Field,
  InputError,
  Tooltip,
  InfoIcon,
  InputModalConstants,
  Link,
  initialiseLiveAuthClient,
  InputModalStyle,
  useState,
  integrationValidationSchema,
  useRef,
  useTranslation,
} from "@/imports-files/components/model/custom-company-integration-modal";
import Modal from "@/components/common-modal/modal";
import { FormModalStyle } from "@/imports-files/components/common-modal/common-modal";
export function InputModal({
  closeState,
  description,
  inputs,
  radios,
  onSubmit,
  initialValues,
  setFormData,
  links,
  selectedItem,
  connectModal,
  selectedRadio,
  setSelectedRadio,
}) {
  const [isAccountConnected, setIsAccountConnected] = useState(false);

  const handleRadioChange = (value, formik) => {
    setSelectedRadio(value);
    if (value === "false") {
      formik.setFieldValue("contract_id", "");
      formik.setFieldValue("company_id", "");
    } else {
      formik.setFieldValue("contract_id", "");
      formik.setFieldValue("company_id", "");
    }
  };
  const formRef = useRef(null);
  const { t, i18n } = useTranslation();
  return (
    <div className={`${InputModalStyle.Modalpopup}`}>
      <div className={`${InputModalStyle.ModalInput}`}>
        <Modal
          type="form"
          heading={t("modal:filter:authentication")}
          closeModal={(event) => {
            closeState(false);
          }}
          filterWidth={true}
          content={
            <div className={`${InputModalStyle.ModalInput__Inner}`}>
          <Formik
            initialValues={initialValues}
            validationSchema={integrationValidationSchema(
              isAccountConnected,
              connectModal,
              selectedRadio,
              t
            )}
            innerRef={formRef}
            onSubmit={(values) => {
              const jobdata = {};

              if (connectModal === "indeed") {
                jobdata.company_name = values.company_name;
                if (values.campaign_tag) {
                  jobdata.campaign_tag = values.campaign_tag;
                }
              } else if (connectModal === "linkedInJobs") {
                jobdata.company_id = values.company_id;
                if (selectedRadio === "false" && values.contract_id) {
                  jobdata.contract_id = values.contract_id;
                }
              }
              if (connectModal === "linkedInJobs") {
                jobdata.company_id = values.company_id;
                if (selectedRadio === "false" && values.contract_id) {
                  jobdata.contract_id = values.contract_id;
                }
              }
              if (connectModal === "totalJobs") {
                jobdata.user_name = values.user_name;
                if (values.password) {
                  jobdata.password = values.password;
                }
              }

              setFormData(jobdata);
              onSubmit();
            }}
          >
            {(formik) => (
              <Form className={InputModalStyle.ModalInput__Form}>
                <div className={InputModalStyle.ModalInput__Description}>
                  {description}
                </div>
                <div className={InputModalStyle.ModalInput__Form__Radio}>
                  {radios?.map((radio, index) => {
                    return (
                      <>
                        <div key={index}>
                          <label
                            className={`Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0`}
                          >
                            <Field
                              type="radio"
                              name="radio"
                              id={radio.id}
                              value={radio.defaultvalue}
                              checked={selectedRadio === radio.defaultvalue}
                              onChange={() =>
                                handleRadioChange(radio.defaultvalue, formik)
                              }
                            />
                            <span
                              className="WrapperRadiocheckmark"
                            ></span>{" "}
                            <span className={`ml5 mt-0`}>{radio.text}</span>
                          </label>
                        </div>
                      </>
                    );
                  })}
                </div>
                {inputs?.map((input, index) => {
                  if (
                    input.name === "contract_id" &&
                    selectedRadio !== "false"
                  ) {
                    return null;
                  }
                  return (
                    <>
                      <div
                        className={`${InputModalStyle.ModalInput__ContentBlock}`}
                        key={index}
                      >
                        <div
                          className={`${InputModalStyle.ModalInput__ContentBlock__flexAlign}`}
                        >
                          <label>
                            {input.label}{" "}
                            {!["campaign_tag"].includes(input.name) && " *"}
                            {input.tooltip && (
                              <span
                                className={
                                  InputModalStyle.ModalInput__ContentBlock__Tooltip
                                }
                              >
                                <Tooltip
                                  className='SimpleTooltip'
                                  content={input.tooltip}
                                  {...InputModalConstants.tooltip}
                                >
                                  <p className={`tooltipwidthinterview270`}>
                                    <InfoIcon />
                                  </p>
                                </Tooltip>
                              </span>
                            )}
                          </label>
                          {["contract_id"].includes(input.name) &&
                            selectedRadio === "false" && (
                              <>
                                <button
                                  className={`
                              ${InputModalStyle.Modal__Container__ContentSection__Block__flexAlign__btn} `}
                                  onClick={async (e) => {
                                    e.preventDefault();
                                    const errors = await formik.validateForm();
                                    initialiseLiveAuthClient(
                                      e,
                                      formik,
                                      selectedItem.idibu_data,
                                      setIsAccountConnected
                                    );
                                  }}
                                >
                                  {" "}
                                {t("modal:filter:connect_an_account")}
                                </button>
                              </>
                            )}
                        </div>
                        {input.description && (
                          <div
                            className={
                              InputModalStyle.ModalInput__ContentBlock__Description
                            }
                          >
                            {{
                              obtainContractId: (
                                <>
                                  <span>
                                    {t("modal:input_modal:contract_id:description")}
                                  </span>
                                </>
                              ),
                              obtainCompanyId: (
                                <>
                                  {t("modal:input_modal:CompanyId:description:company")}{" "}
                                  <span
                                    className={InputModalStyle.ModalInput__Link}
                                  >
                                    <a
                                      href="https://www.linkedin.com/help/linkedin/answer/a415420"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {t("modal:input_modal:CompanyId:description:guide_here")}
                                    </a>
                                  </span>{" "}
                                  {t("modal:input_modal:CompanyId:description:instructions")}
                                </>
                              ),
                            }[input.description] || input.description}
                          </div>
                        )}
                      </div>
                      <div className={InputModalStyle.ModalInput__Form__Table}>
                        <FormikControl
                          control="input"
                          formik={formik}
                          {...input}
                          disabled={
                            input.name === "contract_id" && !isAccountConnected
                          }
                          className={`width80 ${InputModalStyle.Form__Input}`}
                          errorClass={InputModalStyle.Form__error}
                          style={InputError(formik, input.name)}
                          onBlur={() =>
                            formik.setFieldTouched(input.name, true)
                          }
                        />
                      </div>
                    </>
                  );
                })}
                {links?.map((link, index) => (
                  <div
                    className={InputModalStyle.ModalInput__Link}
                    key={index}
                    onClick={(e) => {
                      if (link.onClick) {
                        link.onClick(e);
                      } else if (link.initialiseLiveAuthClient) {
                        initialiseLiveAuthClient(e, formik);
                      }
                    }}
                  >
                    <Link href={link.url}>{link.label}</Link>
                  </div>
                ))}
                    <div
                      className={`${FormModalStyle.Modal__Container__ButtonSection}`}
                    >
                  <Button
                    buttonstyle={InputModalStyle.secondarybtn}
                    onClick={() => {
                      closeState(false);
                    }}
                  >
                        {t("button:cancel")}
                  </Button>
                  <Button
                    buttonstyle={InputModalStyle.primarybtn}
                    type="submit"
                  >
                        {t("button:submit")}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>

           }
        />

        
      </div>
    </div>
  );
}
